var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('ul',_vm._l((_vm.menu),function(item){return _c('li',{key:item.path},[_c('router-link',{attrs:{"to":item.path,"active-class":"active"}},[_c('i',{class:item.icon}),_c('span',{staticClass:"menu-text"},[_vm._v(_vm._s(item.name))])])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }